import { render } from "./filter_xxl.svg?vue&type=template&id=159c8332?inline"
const script = {}
script.render = render

export default script